<template>
    <div>
        <h1 class="section-header">Contact me!</h1>
        <div class="contact-content">
            Resume | email | linkedin | github
        </div>
    </div>
</template>

<script>


export default {
    components: {
    },
    data() {
        return {
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
